import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ExportAsConfig, ExportAsService, SupportedExtensions } from 'ngx-export-as';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { finalize } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { HotelService } from '../../hotel.service';

@Component({
    selector: 'app-hotel-voucher',
    templateUrl: './hotel-voucher.component.html',
    styleUrls: ['./hotel-voucher.component.scss']
})
export class HotelVoucherComponent implements OnInit {

    @ViewChild('print_voucher', { static: false }) print_voucher: ElementRef;
    private subSink = new SubSink();
    voucher: {} = {};
    isLoading: boolean = true;
    noOfAdults: number = 0;
    noOfChilds: number = 0;
    showPayment: boolean = true;
    appRef: any
    config: ExportAsConfig = {
        type: 'pdf',
        elementIdOrContent: 'voucher-print',
        options: {
            jsPDF: {
                orientation: 'landscape'
            },
            pdfCallbackFn: this.pdfCallbackFn // to add header and footer
        }

    };
    paymentData: any;
    constructor(
        private apiHandlerService: ApiHandlerService,
        private util: UtilityService,
        private hotelService: HotelService,
        private exportAsService: ExportAsService,
        private router: Router,
        private swalService: SwalService,
        private ngxService: NgxUiLoaderService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.hotelService.loading.next(true);
        this.activatedRoute.queryParams.subscribe(q => {
            if (!this.util.isEmpty(q)) {
                this.appRef = q.AppReference
                this.bookingConfirmation(q);
            }
        })
        this.ngxService.stop();
    }

    bookingConfirmation(q) {
        console.log(q);
        this.hotelService.loading.next(true);
        this.subSink.sink = this.apiHandlerService.apiHandler('hotelVoucher', 'post', {}, {}, {
            AppReference: q.AppReference
        }).pipe(
            finalize(() => {
                this.hotelService.loading.next(false);
                this.isLoading = false;
            })
        ).subscribe(resp => {
            if (resp.statusCode == 201) {
                this.hotelService.loading.next(false);
                this.voucher = resp.data;
                this.voucher['BookingPaxDetails'].forEach((element, i) => {
                    console.log("element",element)
                    console.log("i",i)
                    if (i < this.voucher['BookingPaxDetails'].length) {
                        if (element['PaxType'] == 'Child') {
                            this.noOfChilds++;
                        } else if (element['PaxType'] == 'Adult') {
                            this.noOfAdults++;
                        }
                    }
                });
            }
        }, err => {
            this.hotelService.loading.next(false);
            console.error(err);
        });
    }

    getNoOfRoomsCount() {
        let totalRoomsBooked: number = 0;
        console.log(" this.voucher['BookingItineraryDetails']", this.voucher)
        this.voucher['BookingItineraryDetails'].forEach(o => {
            totalRoomsBooked += o['BlockQuantity'];
        });
        return totalRoomsBooked;
    }

    getDatesFormat(date) {
        if (date != null) {
            date = date.split(' ')[0];
            let d = new Date(date).getDate(), m = new Date(date).toDateString().split(' ')[1], y = new Date(date).getFullYear(), day = new Date(date).toDateString().split(' ')[0];
            day = this.util.getWeekDay(day);
            return `${day + ',&nbsp;' + d + '&nbsp;' + m + '&nbsp;' + y}`;
        }
    }

    getTimes(t: string): string {
        if (t != null) {
            t = t.split(' ')[1];
            let time = Number(t.split(':')[0]);
            if (time > 12) {
                return `${t} PM`;
            } else if (time < 12) {
                return `${t} AM`;
            } if (time == 12) {
                return `${t} PM`;
            }
        }
    }

    getRoomType(roomName: string): string {
        roomName = roomName.split('-')[0].trim();
        return `${roomName}`;
    }

    getTotalAmnt() {
        let totalAmnt: number = 0;
        this.voucher['BookingItineraryDetails'].forEach(o => {
            totalAmnt += o.TotalFare;
        });
        return totalAmnt;
    }

    getNoOfNights(i, o): number {
        let checkin = Number(new Date(i).getTime()), checkout = Number(new Date(o).getTime()), nights: number = 0;
        nights = (checkout - checkin) / (1000 * 60 * 60 * 24);
        return nights;
    }

    getBoardType(roomName: string): string {
        let temp = roomName.split('-'), boardType = '';
        temp.forEach((s, i) => {
            if (i > 0 && i < temp.length - 1) {
                boardType += s;
                boardType += (i < temp.length - 2) ? '-' : '';
            }
        })
        return `${boardType}`;
    }

    // getCancelationPolicy(cancellationPolicy) {
    //     let policy = JSON.parse(cancellationPolicy.replace(/'/gi, "\""));
    //     if (policy['NonRefundable']) {
    //         return `Non Refundable`;
    //     } else if (!policy['NonRefundable']) {
    //         let penalty = '';
    //         if (typeof policy['CancelPenalty'] == 'object') {
    //             policy['CancelPenalty'].forEach((element, i) => {
    //                 penalty += `Cancellation made <strong>${element.HoursBefore} hours</strong> before checkin <strong>${this.voucher['BookingDetails']['Currency'] + ' ' + element.Penalty.Value}</strong> will be charged as cancellation penalty`;
    //                 if (policy['CancelPenalty'].length - 1 != i) {
    //                     penalty += '<br>'
    //                 }
    //             });
    //             return penalty;
    //         } else {
    //             penalty += `You may cancel your booking for <strong>no charge</strong> on or before <strong>${policy['CancelPenalty']}</strong>`;
    //             return penalty;
    //         }
    //     }

    // }

    getFormtedStatus(status: string) {
        let tmpStatus = status.split('_');
        return `${tmpStatus[0] + '&nbsp;' + tmpStatus[1]}`
    }

    public downloadPDF1(isWithPrice: boolean) {
        window['html2canvas'] = html2canvas;
        const date = new Date().toDateString();
        const doc = new jsPDF({
            orientation: 'p',
            unit: 'pt',
            format: 'a4',
        });
        const content = this.print_voucher.nativeElement;
        doc.html(content, {
            html2canvas: {
                allowTaint: true,
                useCORS: true,
                scale: 600 / content.scrollWidth
            },
            callback: async (doc) => {
                doc.save(`${this.voucher['BookingDetails']['AppReference']}- ${this.voucher['BookingDetails']['ConfirmationReference']} -${date}.pdf`);
                console.log('Success');
                this.swalService.alert.success();
            }
        });
    }

    
  paymentConfirm() {
    this.intitiatePayment();
 }
 
 intitiatePayment(){
   let date = (new Date().getTime()).toString();
   const userId = this.util.readStorage('b2cUser', sessionStorage)['id']
   const order_id = `IR${date.substring(10)}${date.substring(0, 7)}${date.substring(7)}`;
   let payload = {
       app_reference: this.appRef,
       order_id: order_id,
       payment_type: "Stripe",
       merchantInvoiceNumber: "Inv002",
       source: "hotel",
       userId: userId ? userId : 0,
   }
   localStorage.setItem('orderId',order_id);
   localStorage.setItem('activityPLAR',this.appRef);
   this.subSink.sink = this.apiHandlerService.apiHandler('transactionInit', 'post', '', '', payload).subscribe(res => {
       if (res) {
           this.paymentData = res.data;
           const redirectUrl = this.paymentData.url;
           window.location.href = redirectUrl;
       }
   });
 }


    public downloadPDF() {
        window.scroll(0, 0);
        var data = document.getElementById('print_voucher');
        const date = new Date().toDateString();
        setTimeout(() => {
            html2canvas(data, {
                allowTaint: true,
                useCORS: true
            }).then(canvas => {
                const contentDataURL = canvas.toDataURL('image/png', 1.0)
                let pdf = new jsPDF('p', 'mm', 'a4');
                const imgProps = pdf.getImageProperties(contentDataURL);
                var width = pdf.internal.pageSize.getWidth() - 3;
                var height = (imgProps.height * width) / imgProps.width;
                pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
                this.swalService.alert.success();
                pdf.save(`${this.voucher['BookingDetails']['AppReference']}-${date}.pdf`);
            });
        }, 1000)
    }

    download(type: SupportedExtensions, isWithPrice: boolean, orientation?: string) {
        this.config.type = type;
        if (orientation) {
            this.config.options.jsPDF.orientation = orientation;
        }
        const date = new Date().toDateString();
        this.exportAsService.save(this.config, `${this.voucher['BookingDetails']['AppReference']}- ${this.voucher['BookingDetails']['ConfirmationReference']} -${date}`).subscribe((_) => {
            console.log(`success`);
        }, (err) => {
            console.log(err);
        });
    }

    cancel() {
        this.router.navigate(['/hotel/hotel-cancellation'], {
            queryParams: { "AppReference": this.voucher['BookingDetails']['AppReference'] }
        })
    }

    pdfCallbackFn(pdf: any) {
        // example to add page number as footer to every page of pdf
        const noOfPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= noOfPages; i++) {
            pdf.setPage(i);
            pdf.text('Page ' + i + ' of ' + noOfPages, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 5);
        }
    }

    downloadWithPrice(t: boolean) {
        console.log(t);
        this.showPayment = t;
    }

    getTotalFare(itinarary: any) {
        let totalFare: any = 0;
        itinarary.forEach(element => {
            totalFare += element.TotalFare;
        });
        return totalFare;
    }

    getHotelPhoto(imgArrStr) {
        let imgArray = JSON.parse(imgArrStr.replace(/'/gi, "\""));
        return imgArray;
    }

    ngOnDestroy(): void {
        this.subSink.unsubscribe();
    }

}
